import axios from 'axios'
import { Toast } from 'vant'

export const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
})

request.interceptors.response.use((response) => {
  const res = response.data
  if (res.code !== 200) {
    Toast.fail(res.msg)
  }
  return response.data
})
